import React, { PropsWithChildren } from "react";
type PropsType = PropsWithChildren<{}>;
class ErrorBoundary extends React.Component<PropsType, { hasError: boolean }> {
  constructor(props: PropsType) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {}

  render() {
    if (this.state.hasError) {
      // @TODO: Fallback UI, should be a complete error page
      // Barebone for now
      return (
        <>
          <h1>The application encountered an issue</h1>
          <p>Please refresh the page.</p>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
